import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

import UnifiedTest from "../../public/test/unified-test";
import TestPreviewAPI from "../../../services/api/test-preview.api";
import { userAtom } from "../../../services/atoms/auth.atoms";
import { ROUTES } from "../../../helpers/constants";

// Vista previa del test para superadmins: el test unificado real (mismas preguntas,
// pantallas y funciones que ve un candidato) en modo `preview`, que no guarda nada y
// trae un panel para saltar entre pantallas. Va a pantalla completa, fuera del menú
// del panel, para verse igual que en el link del candidato.
const TestPreview = () => {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom)?.data;
  const [test, setTest] = useState(null);
  const [failed, setFailed] = useState(false);
  // Cambiarla vuelve a montar el test: "Bienvenida" en el panel empieza de cero.
  const [run, setRun] = useState(0);

  const load = useCallback(() => {
    setFailed(false);
    TestPreviewAPI.get()
      .then((res) => setTest({ ...res.data, collaboratorTestID: 'vista-previa' }))
      .catch((error) => {
        console.error('No se pudo cargar la vista previa del test', error);
        setFailed(true);
      });
  }, []);

  useEffect(() => {
    if (user?.isSuperAdmin) load();
  }, [user?.isSuperAdmin, load]);

  if (!user?.isSuperAdmin) {
    return (
      <div className="test-loading test-load-error">
        <h1>Sin acceso</h1>
        <p>La vista previa del test es solo para superadmins.</p>
        <button type="button" onClick={() => navigate(ROUTES.HOME.route)}>Volver al panel</button>
      </div>
    );
  }

  if (failed) {
    return (
      <div className="test-loading test-load-error">
        <h1>No se pudo cargar la vista previa</h1>
        <p>Revisa tu conexión e inténtalo de nuevo.</p>
        <button type="button" onClick={load}>Reintentar</button>
      </div>
    );
  }

  if (!test) {
    return (
      <div className="test-loading">
        <h1>Cargando...</h1>
      </div>
    );
  }

  return (
    <UnifiedTest
      key={run}
      test={test}
      preview
      onPreviewRestart={() => { setRun((n) => n + 1); window.scrollTo(0, 0); }}
      onPreviewExit={() => navigate(ROUTES.HOME.route)}
    />
  );
};

export default TestPreview;
